<template>
  <v-navigation-drawer
    v-model="sideNavOpen"
    app
    disable-resize-watcher
    temporary
  >

    <div class="logo-background">
      <div class="text-caption pa-1 pr-3 text-right">Version {{ version }}</div>
      <div class="pt-4 pb-3 text-center">
        <router-link
          :to="{name: 'Home'}"
          @click="sideNavOpen = false"
        >
          <img
            src="/img/logo.png"
            class="logo"
          />
        </router-link>
      </div>
    </div>

    <v-list>
      <v-list-item
        to="/"
        prepend-icon="mdi-home"
        title="Home"
        @click="sideNavOpen = false"
      />

      <v-list-item
        :to="{ name: 'tournaments' }"
        prepend-icon="mdi-trophy-outline"
        title="Tournaments"
        @click="sideNavOpen = false"
      />

      <v-list-item
        v-if="showLeagues"
        :to="{ name: 'leagues' }"
        prepend-icon="mdi-flag-checkered"
        title="Leagues"
        @click="sideNavOpen = false"
      />

      <v-divider />

      <v-list-item
        prepend-icon="mdi-help-circle"
        title="Help"
        @click="showHelp"
      />
    </v-list>

    <template v-slot:append>
      <div class="text-caption text-center pa-2">
        &copy; 2026 FoosMonster
      </div>
    </template>
  </v-navigation-drawer>
</template>

<script>
import { useAppStore } from "@/store";
import { db, dbFns } from "@/db";

export default {
  name: "side-nav",
  inject: ["$dialog"],
  setup () {
    const store = useAppStore();
    return { store };
  },
  data () {
    return {
      isMember: false,
      membershipUnsubscribe: null
    };
  },
  created () {
    this.version = `${__APP_VERSION__} (${__APP_GIT_VERSION__})`;
  },
  beforeUnmount () {
    this.teardownMembershipListener();
  },
  watch: {
    currentUserId: {
      immediate: true,
      handler () {
        this.setMembershipListener();
      }
    }
  },
  computed: {
    sideNavOpen: {
      get () {
        return this.store.sideNavOpen;
      },
      set (open) {
        this.store.setSideNavOpen({ open });
      }
    },
    currentUserId () {
      return this.store.isAuthenticated ? this.store.user.id : null;
    },
    showLeagues () {
      if (!this.store.isAuthenticated) return false;
      if (this.store.user.role === "owner") return true;
      return this.isMember;
    }
  },
  methods: {
    setMembershipListener () {
      this.teardownMembershipListener();
      this.isMember = false;
      if (!this.store.isAuthenticated) return;
      const { collection, query, where, onSnapshot, limit } = dbFns;
      const q = query(
        collection(db, "members"),
        where("memberUserId", "==", this.store.user.id),
        limit(1)
      );
      this.membershipUnsubscribe = onSnapshot(q, (snapshot) => {
        this.isMember = snapshot.docs.length > 0;
      });
    },
    teardownMembershipListener () {
      if (this.membershipUnsubscribe) this.membershipUnsubscribe();
      this.membershipUnsubscribe = null;
    },
    showHelp () {
      this.$dialog.override("help");
      this.sideNavOpen = false;
    }
  }
};
</script>

<style lang="css" scoped>

.v-navigation-drawer {
  display: flex;
  flex-direction: column;
}

.logo-background {
  background: #E8F4F8;
}

.logo {
  display: block;
  width: 100%;
  height: auto;
  margin: 0;
  padding: 0;
}

</style>
